import { cn } from '@cointracker/styleguide';
import EmbeddedDemoImage from 'src/assets/hr-block-header.png';

export function TopHeading() {
  return (
    <div
      className={cn(
        'h-140 flex w-full max-w-[calc(100dvw-240px)] flex-row place-items-center justify-between gap-8 border-sidebar-border bg-background-default text-text-primary',
        'transition-translate fixed left-[240px] right-0 top-0 z-20 translate-y-0 shadow-elevation-1 duration-150 ease-linear',
      )}
    >
      <img src={EmbeddedDemoImage} alt="HR Block Header" />
    </div>
  );
}
